"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const type_1 = require("../type");
function default_1(props) {
    const { clock } = props;
    return (react_1.default.createElement("div", { className: "glx--cube" },
        react_1.default.createElement("figure", { className: "glx--clock glx-no-select" },
            react_1.default.createElement("div", { className: "face top" },
                react_1.default.createElement("p", { id: "s" }, (0, type_1.pad)(clock.s))),
            react_1.default.createElement("div", { className: "face front" },
                react_1.default.createElement("p", { id: "m" }, (0, type_1.pad)(clock.m))),
            react_1.default.createElement("div", { className: "face left" },
                react_1.default.createElement("p", { id: "h" }, (0, type_1.pad)(clock.h))))));
}
exports.default = default_1;
